import {api} from "@core/api";
import {Selectors} from "@core/store/selectors";
import {skipToken} from "@reduxjs/toolkit/query";
import {useSelector} from "react-redux";
import {isChatbotOn} from "./stream";

// L'argomento è solo la chiave di cache. X-Sw-Tenant-Id resta in baseQuery.
const useTenantChatStatus = (skip = false) => {
  const role = useSelector(Selectors.userRole);
  const tenantId = useSelector(Selectors.tenantId);
  const query = api.useFetchChatStatusQuery(tenantId ?? skipToken, {
    skip: skip || role === "MACHINE" || !tenantId,
  });
  return {
    ...query,
    enabled: isChatbotOn(query.currentData, query.error),
  };
};

export {useTenantChatStatus};
